import React from 'react';
import { motion } from 'framer-motion';
interface HeroProps {
  onCTAClick: () => void;
}
export function Hero({
  onCTAClick
}: HeroProps) {
  return <section className="relative w-full py-10 sm:py-24 lg:py-32 overflow-hidden" data-id="element-142">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-144">
          <div className="mb-4 sm:mb-6" data-id="element-145">
            <p className="sm:text-2xl lg:text-3xl font-display font-semibold text-gold mb-1 text-[18px]" data-id="element-146">
              MEGAPACK EMPRENDEDORA DE MODA
            </p>
            <p className="text-sm sm:text-xl text-violet-100/80" data-id="element-147">
              8 Guías + 8 Bonos
            </p>
          </div>

          <h1 className="font-display text-3xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight mb-6 sm:mb-8" data-id="element-148">
            Todo tu año de negocio de ropa resuelto
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mb-6 sm:mb-8" data-id="element-149">
          <img src="https://cdn.magicpatterns.com/uploads/6Rknpdm2PCapWLkv45mQAk/Mockup.png" alt="MEGAPACK EMPRENDEDORA DE MODA - 8 Guías completas y bonos premium para emprendedoras de moda en Argentina" width={717} height={717} loading="eager" decoding="async" fetchPriority="high" className="w-[70%] h-auto max-w-[717px] mx-auto rounded-lg shadow-2xl" data-id="element-150" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} data-id="element-151">
          <div className="bg-green/10 border-l-4 border-green p-4 sm:p-6 mb-6 sm:mb-8 rounded-r-lg text-left" data-id="element-152">
            <p className="text-green text-base sm:text-xl font-semibold mb-2 sm:mb-3 leading-relaxed" data-id="element-153">
              Tu plan completo para vender ropa listo: proveedores, precios,
              Instagram, showroom y clientas fieles. Sin improvisar. Sin
              estancarte.
            </p>
            <p className="text-violet-100/70 text-xs sm:text-base" data-id="element-154">
              PDF Digital · Acceso Inmediato · Desde cero hasta tu propia marca
            </p>
          </div>

          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.95
        }} onClick={onCTAClick} className="w-full sm:w-auto bg-green hover:bg-green/90 text-white font-bold text-base sm:text-lg px-8 py-4 sm:px-12 sm:py-5 rounded-lg transition-colors duration-300 shadow-lg hover:shadow-xl mb-4" data-id="element-155">
            💥 QUIERO MI MEGAPACK AHORA
          </motion.button>

          <p className="text-[10px] sm:text-sm text-violet-100/60 flex flex-wrap justify-center gap-x-2 gap-y-1" data-id="element-156">
            <span data-id="element-157">Garantía 7 días</span>
            <span className="hidden sm:inline" data-id="element-158">·</span>
            <span data-id="element-159">Pago seguro</span>
            <span className="hidden sm:inline" data-id="element-160">·</span>
            <span data-id="element-161">Mercado Pago</span>
            <span className="hidden sm:inline" data-id="element-162">·</span>
            <span data-id="element-163">+4.800 emprendedoras</span>
            <span className="hidden sm:inline" data-id="element-164">·</span>
            <span data-id="element-165">4.9 Rating</span>
            <span className="hidden sm:inline" data-id="element-166">·</span>
            <span data-id="element-167">Todo Argentina</span>
          </p>
        </motion.div>
      </div>
    </section>;
}